/** @file A world point rounded per axis to its grid step, halves toward +infinity (design 21.4). */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/** Steps per unit `1 / step`, made whole when within 1e-9 of it, so half steps round exactly. */
const perUnit = (step: number): number => {
  const k = 1 / step;
  const whole = Math.round(k);
  return Math.abs(k - whole) < 1e-9 ? whole : k;
};

/** `floor(v k + 0.5) / k` per axis with `k = 1 / step` (halves round toward +infinity); `-0` becomes `0`. */
export function roundWorld(p: Vec3, grid: Vec3): Vec3 {
  const at = (v: number, step: number): number => {
    const k = perUnit(step);
    return Math.floor(v * k + 0.5) / k + 0;
  };
  return [at(p[0], grid[0]), at(p[1], grid[1]), at(p[2], grid[2])];
}
